import React from "react";
import Hero from "./landingPage/Hero";
import { Helmet } from "react-helmet";
import UpcomingEvents from "./landingPage/UpcomingEvents";
import Sponsors from "./landingPage/Sponsors";
import Join from "./landingPage/Join";

const Main = () => {
  return (
    <>
      <Helmet>
        <meta property="og:title" content="Vegan Strong PlantBuilt Team" />
        <meta property="og:description" content="PlantBuilt: Over a Decade of Compassionate Strength" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://plantbuilt.com/" />
        <meta property="og:image" content="https://plantbuilt.com/PLANTBUILT_TEAM2025.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Vegan Strong PlantBuilt Team" />
        <meta name="twitter:description" content="PlantBuilt: Over a Decade of Compassionate Strength" />
        <meta name="twitter:image" content="https://plantbuilt.com/PLANTBUILT_TEAM2025.jpg" />
      </Helmet>
      <Hero />
      <UpcomingEvents />
      <Sponsors />
      <Join />
    </>
  );
};

export default Main;
